import React from "react";

interface CommentCursorProps {
  style: {
    left: number;
    top: number;
  };
}

export const CommentCursor: React.FC<CommentCursorProps> = ({ style }) => {
  return (
    <div
      className="fixed w-6 h-6 pointer-events-none"
      style={{
        ...style,
        transform: "translate(-50%, -50%)",
        zIndex: 2147483647, // Maximum z-index value
      }}
      data-comment-cursor
    >
      <div className="w-full h-full rounded-full bg-indigo-600 opacity-50" />
    </div>
  );
};

export default CommentCursor;
